import { useEffect } from 'react';
import { useLegendDimensionContext } from 'routes/Explore/components/Contexts/LegendDimensionContext/LegendDimensionContext';
import { SerieT } from '../../types';

export const useSetLegendDimension = (
    yColumn: ResponseColumnT,
    zColumn: ResponseColumnT | undefined,
    series: SerieT[] | undefined,
    treeValueTranslations?: Record<string, string | undefined>,
) => {
    const { setLegendDimension } = useLegendDimensionContext();
    useEffect(() => {
        if (series !== undefined) {
            const dimensionValues = series.map((s) => s.name);
            setLegendDimension({
                key: zColumn ? zColumn.key : yColumn.key,
                dimensionValues,
                translations: treeValueTranslations,
            });
        }
    }, [yColumn, zColumn, JSON.stringify(series)]);
};

export const useSetPieLegendDimension = (
    xColumn: ResponseColumnT,
    dimensions: string[],
) => {
    const { setLegendDimension } = useLegendDimensionContext();
    useEffect(() => {
        setLegendDimension({
            key: xColumn.key,
            dimensionValues: dimensions,
        });
    }, [xColumn, JSON.stringify(dimensions)]);
};
